import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=f3653bde&scoped=true&"
import script from "./step2.vue?vue&type=script&lang=js&"
export * from "./step2.vue?vue&type=script&lang=js&"
import style0 from "./step2.vue?vue&type=style&index=0&id=f3653bde&lang=less&scoped=true&"
import style1 from "./step2.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3653bde",
  null
  
)

component.options.__file = "step2.vue"
export default component.exports